// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"314":"14d7ac7215603e01","962":"9a74a25887cef94e"}[chunkId] + ".js";
};